import {useCallback, useMemo} from 'react'
import {useHistory, useLocation} from 'react-router-dom'

type Filters = Record<string, string>

const FILTERS_KEY = 'filters'
const FILTERS_REGEX = new RegExp(`^${FILTERS_KEY}\\[(.+)\\]$`)

// Сохраняем в query как объект в bracket notation, чтобы не мешать с остальными query параметрами
export function useFilters() {
  const location = useLocation()
  const history = useHistory()

  const filters = useMemo(() => {
    const params = new URLSearchParams(location.search)
    const result: Filters = {}
    params.forEach((value, name) => {
      const match = name.match(FILTERS_REGEX)
      if (match) {
        result[match[1]] = value
      }
    })
    return result
  }, [location.search])

  const setFilter = useCallback(
    (id: string, value?: string) => {
      const name = `${FILTERS_KEY}[${id}]`
      const params = new URLSearchParams(history.location.search)
      if (value) {
        params.set(name, value)
      } else {
        params.delete(name)
      }
      history.replace({search: params.toString()})
    },
    [history],
  )

  const setFilters = useCallback(
    (newFilters: Filters) => {
      const params = new URLSearchParams(history.location.search)
      params.forEach((_, name) => {
        if (FILTERS_REGEX.test(name)) {
          params.delete(name)
        }
      })
      Object.entries(newFilters).forEach(([id, value]) => {
        params.set(`${FILTERS_KEY}[${id}]`, value)
      })
      history.replace({search: params.toString()})
    },
    [history],
  )

  return {filters, setFilter, setFilters}
}
